// extracted by mini-css-extract-plugin
module.exports = {"fakeShadow":"fakeshadow_fakeShadow__mdSo5"};